import React from "react";
import { Link } from "react-router-dom";
import { imgurl } from "../../baseurl";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

function ProductCardSlideMobile({
  categoryName,
  category_slug,
  products = [],
  loading = false,
}) {
  return (
    <div className="mobile-product-slider mb-4">
      {/* 🔹 Header Section */}
      <div className="d-flex justify-content-between align-items-center mb-3 px-3">
        <h6 className="fw-bold mb-0" style={{ fontSize: "1.1rem", color: "#222" }}>
          {categoryName || <Skeleton width={120} />}
        </h6>
        {!loading && (
          <Link to={`/category/${category_slug}`} className="view-all-link">
            See All <i className="bi bi-chevron-right" style={{ fontSize: "10px" }}></i>
          </Link>
        )}
      </div>

      {/* 🔹 Swiper for Mobile */}
      <Swiper
        spaceBetween={12}
        slidesPerView={2.3} // Peeking effect
        slidesOffsetBefore={15} // Aligns first card with header
        slidesOffsetAfter={15}
        className="px-0"
      >
        {loading
          ? Array.from({ length: 4 }).map((_, idx) => (
              <SwiperSlide key={idx}>
                <div className="product-card-mob-modern">
                  <Skeleton height={140} borderRadius={12} />
                  <div className="p-2">
                    <Skeleton height={15} width="80%" />
                    <Skeleton height={15} width="40%" className="mt-1" />
                  </div>
                </div>
              </SwiperSlide>
            ))
          : products.map((p, idx) => (
              <SwiperSlide key={idx}>
                <Link to={`/product/${p.slug}`} className="text-decoration-none">
                  <div className="product-card-mob-modern">
                    <div className="product-image-wrapper">
                      <img
                        src={`${imgurl}${p.featured_image || "/no-image.jpg"}`}
                        alt={p.name}
                        className="product-img-mob"
                      />
                    </div>
                    <div className="product-details p-2">
                      <h6 className="product-name-text">{p.name}</h6>
                      <div className="d-flex align-items-center gap-1">
                         <span className="price-text">₹{p.price}</span>
                         {p.old_price && <span className="old-price-text">₹{p.old_price}</span>}
                      </div>
                    </div>
                  </div>
                </Link>
              </SwiperSlide>
            ))}
      </Swiper>

      <style>{`
        .view-all-link {
          font-size: 12px;
          color: #ff4757;
          text-decoration: none;
          font-weight: 600;
          background: #fff0f0;
          padding: 4px 12px;
          border-radius: 20px;
        }

        .product-card-mob-modern {
          background: #fff;
          border-radius: 12px;
          border: 1px solid #f1f1f1;
          overflow: hidden;
          transition: transform 0.2s ease;
          box-shadow: 0 2px 8px rgba(0,0,0,0.04);
        }

        .product-card-mob-modern:active {
          transform: scale(0.97);
        }

        .product-image-wrapper {
          width: 100%;
          aspect-ratio: 1 / 1;
          background: #f9f9f9;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .product-img-mob {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .product-name-text {
          font-size: 12px;
          color: #444;
          font-weight: 500;
          margin-bottom: 4px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          height: 32px;
          line-height: 1.3;
        }

        .price-text {
          font-size: 14px;
          font-weight: 700;
          color: #000;
        }

        .old-price-text {
          font-size: 10px;
          color: #999;
          text-decoration: line-through;
        }
      `}</style>
    </div>
  );
}

export default ProductCardSlideMobile;